import { render } from "./credit.vue?vue&type=template&id=7e45726e&scoped=true"
import script from "./credit.vue?vue&type=script&lang=js"
export * from "./credit.vue?vue&type=script&lang=js"

import "./credit.vue?vue&type=style&index=0&id=7e45726e&lang=scss&scoped=true"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e45726e"]])

export default __exports__